/** @format */

function shouldIgnoreScroll() {
  const el = document.activeElement;

  if (!el) return false;

  return (
    el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable
  );
}

function isKeyboardOpen() {
  return (
    window.visualViewport &&
    window.visualViewport.height < window.innerHeight * 0.25 // agar perubahan ukuran sedikit di browser tidak memicu stop hide/show header
  );
}

// Handle Header With Auto Hide and Smart Tall Sidebar Sticky Math
function handleHeaderWithAutoHide() {
  const header = document.querySelector("header");
  const ticker = document.getElementById("ticker");

  const headerCategories = document.getElementById("header-categories");
  const forumBanner = document.getElementById("suar-banner-container");

  const stickySubscribeForm = document.querySelector(
    ".sticky-subscribe-form .sticky",
  );
  const sidebarTrack = document.querySelector(".suar-sidebar-container");
  const stickyVideoEmbed = document.querySelector(
    ".post-content-video-container-mobile",
  );
  const articleProgressTrack = document.getElementById(
    "article-scroll-progress-bar",
  );

  const updateHeaderHeight = () => {
    let headerHeight = header.clientHeight;
    if (ticker && ticker.dataset.visible === "hidden") {
      headerHeight = header.clientHeight;
    }
    return headerHeight;
  };

  let headerHeight = updateHeaderHeight();
  let oldScrollY = window.scrollY;

  const updatePositions = () => {
    headerHeight = updateHeaderHeight();

    const viewportHeight = window.innerHeight;
    const sidebarHeight = sidebarTrack ? sidebarTrack.clientHeight : 0;

    // A sidebar is considered tall if its height exceeds the available viewport space
    const isTallSidebar =
      sidebarTrack && sidebarHeight + headerHeight + 40 > viewportHeight;

    // Update ticker position
    if (ticker && ticker.dataset.visible !== "hidden") {
      ticker.style.transform = `translateY(${headerHeight}px)`;
    }

    // Update sticky form position
    if (stickySubscribeForm) {
      stickySubscribeForm.style.top = `${headerHeight + 146}px`;
    }
    if (articleProgressTrack) {
      const articleBody = document.querySelector(
        ".post-content, .post-body-container, article",
      );
      const articleRect = articleBody.getBoundingClientRect();
      const articleTop = articleRect.top + window.scrollY;

      const currentScroll = window.scrollY;

      if (currentScroll < articleTop - 100) {
        articleProgressTrack.style.top = `0px`;
      } else {
        articleProgressTrack.style.top = `${headerHeight}px`;
      }
    }
    if (stickyVideoEmbed) {
      stickyVideoEmbed.style.top = `${headerHeight}px`;
    }

    // Update sidebar track position on initial load / resize adjustments
    if (sidebarTrack) {
      if (isTallSidebar) {
        // Your negative top offset formula (with a clean 24px bottom spacing padding)
        sidebarTrack.style.top = `${viewportHeight - sidebarHeight - 24}px`;
      } else {
        sidebarTrack.style.top = `${headerHeight + 146}px`;
      }
    }
  };

  // Initialize positions
  updatePositions();

  const adjustTranslate = (e) => {
    if (shouldIgnoreScroll() || isKeyboardOpen()) return;

    headerHeight = updateHeaderHeight();

    const isScrollingDown = oldScrollY < window.scrollY;
    const shouldHideHeader = window.scrollY >= headerHeight;

    const viewportHeight = window.innerHeight;
    const sidebarHeight = sidebarTrack ? sidebarTrack.clientHeight : 0;
    const isTallSidebar =
      sidebarTrack && sidebarHeight + headerHeight + 40 > viewportHeight;

    if (isScrollingDown) {
      if (shouldHideHeader) {
        // --- STATE A: Header is Hidden ---
        // header.style.transform = "translateY(-100%)";
        if (forumBanner) forumBanner.style.gridTemplateRows = "0fr";
        headerCategories.classList.add("hide");
        if (ticker && ticker.dataset.visible !== "hidden") {
          ticker.style.transform = "translateY(0)";
        }

        if (stickySubscribeForm)
          stickySubscribeForm.style.top = `${headerHeight + 74}px`;
        if (articleProgressTrack)
          articleProgressTrack.style.top = `${headerHeight}px`;

        if (stickyVideoEmbed) {
          let additional = articleProgressTrack
            ? articleProgressTrack.clientHeight
            : 0;

          const articleBody = document.querySelector(
            ".post-content, .post-body-container, article",
          );
          const articleRect = articleBody.getBoundingClientRect();
          const articleTop = articleRect.top + window.scrollY;

          const currentScroll = window.scrollY;

          if (currentScroll < articleTop - 100) {
            additional = 0;
          }
          stickyVideoEmbed.style.top = `${headerHeight + additional}px`;
        }

        if (sidebarTrack) {
          if (isTallSidebar) {
            // Remains perfectly anchored to the bottom viewport bezel
            sidebarTrack.style.top = `${viewportHeight - sidebarHeight - 24}px`;
          } else {
            sidebarTrack.style.top = "146px";
          }
        }
      } else {
        // --- STATE B: Header is Visible (Scrolling Down Early) ---
        // header.style.transform = "translateY(0)";
        if (forumBanner) forumBanner.style.gridTemplateRows = "1fr";
        headerCategories.classList.remove("hide");
        if (ticker && ticker.dataset.visible !== "hidden") {
          ticker.style.transform = `translateY(${headerHeight}px)`;
        }

        if (stickySubscribeForm)
          stickySubscribeForm.style.top = `${headerHeight + 66}px`;
        if (articleProgressTrack)
          articleProgressTrack.style.top = `${headerHeight}px`;

        if (stickyVideoEmbed) {
          let additional = articleProgressTrack
            ? articleProgressTrack.clientHeight
            : 0;

          const articleBody = document.querySelector(
            ".post-content, .post-body-container, article",
          );
          const articleRect = articleBody.getBoundingClientRect();
          const articleTop = articleRect.top + window.scrollY;

          const currentScroll = window.scrollY;

          if (currentScroll < articleTop - 100) {
            additional = 0;
          }
          stickyVideoEmbed.style.top = `${headerHeight + additional}px`;
        }

        if (sidebarTrack) {
          if (isTallSidebar) {
            sidebarTrack.style.top = `${viewportHeight - sidebarHeight - 24}px`;
          } else {
            sidebarTrack.style.top = `${headerHeight + 90}px`;
          }
        }
      }
    } else {
      // --- STATE C: Header Reveals (Scrolling Up) ---
      // header.style.transform = "translateY(0)";
      if (forumBanner) forumBanner.style.gridTemplateRows = "1fr";
      headerCategories.classList.remove("hide");
      if (ticker && ticker.dataset.visible !== "hidden") {
        ticker.style.transform = `translateY(${headerHeight}px)`;
      }

      if (stickySubscribeForm)
        stickySubscribeForm.style.top = `${headerHeight + 66}px`;
      if (articleProgressTrack)
        articleProgressTrack.style.top = `${headerHeight}px`;

      if (stickyVideoEmbed) {
        let additional = articleProgressTrack
          ? articleProgressTrack.clientHeight
          : 0;

        const articleBody = document.querySelector(
          ".post-content, .post-body-container, article",
        );
        const articleRect = articleBody.getBoundingClientRect();
        const articleTop = articleRect.top + window.scrollY;

        const currentScroll = window.scrollY;

        if (currentScroll < articleTop - 100) {
          additional = 0;
        }

        stickyVideoEmbed.style.top = `${headerHeight + additional}px`;
      }

      if (sidebarTrack) {
        if (isTallSidebar) {
          sidebarTrack.style.top = `${viewportHeight - sidebarHeight - 24}px`;
        } else {
          sidebarTrack.style.top = `${headerHeight + 90}px`;
        }
      }
    }

    oldScrollY = window.scrollY;
  };

  window.addEventListener("scroll", adjustTranslate);

  // Run reassessment checks if the window gets resized or orientation flips
  window.addEventListener("resize", updatePositions);

  // const ro = new ResizeObserver((entries) => {
  //     adjustTranslate();
  // });

  // ro.observe(header);

  return updatePositions;
}

function handleHeader() {
  const header = document.querySelector("header");
  const ticker = document.getElementById("ticker");
  const stickySubscribeForm = document.querySelector(
    ".sticky-subscribe-form .sticky",
  );

  // Create the global updateHeaderPositions function
  window.updateHeaderPositions = function () {
    const headerHeight = header.clientHeight;

    // Always keep header at top
    header.style.top = "0px";
    header.style.transform = "translateY(0)";

    // Position ticker below header if visible
    if (ticker && ticker.dataset.visible === "visible") {
      ticker.style.top = `${headerHeight}px`;
      ticker.style.transform = "translateY(0)";
    }

    // Update sticky form position if it exists
    if (stickySubscribeForm) {
      stickySubscribeForm.style.top = `${headerHeight + 16}px`;
    }
  };

  // Initialize positions
  window.updateHeaderPositions();

  // Update positions on window resize
  window.addEventListener("resize", () => {
    window.updateHeaderPositions();
  });
}

function handleTicker() {
  const ticker = document.getElementById("ticker");
  if (ticker) {
    const tickerVisibility = localStorage.getItem("ticker");
    if (tickerVisibility === "hidden" || tickerVisibility === "visible") {
      ticker.dataset.visible = tickerVisibility;
      localStorage.setItem("ticker", tickerVisibility);
    }

    const closeTicker = document.getElementById("close-ticker");
    if (closeTicker) {
      closeTicker.addEventListener("click", () => {
        ticker.dataset.visible = "hidden";
        localStorage.setItem("ticker", "hidden");

        // Update header positions after ticker is hidden
        setTimeout(() => {
          if (window.updateHeaderPositions) {
            window.updateHeaderPositions();
          }
        }, 10);
      });
    }

    const scrollers = document.querySelectorAll(".scroller");
    const infiniteScrollAnimation = () => {
      scrollers.forEach((scroller) => {
        const scrollerInner = scroller.querySelector(".scroller-inner");
        const scrollerContent = Array.from(scrollerInner.children);
        scrollerContent.forEach((el) => {
          const duplicatedItem = el.cloneNode(true);
          scrollerInner.appendChild(duplicatedItem);
        });
      });
    };
    infiniteScrollAnimation();
  }
}

//Handle Mobile Navigation
function handleMobileNavigation() {
  const navbar = document.querySelector("header");
  const navItems = document.getElementById("nav-items");
  const searchBoxDesktop = document.getElementById("search-box-desktop");
  const headerCategories = document.getElementById("header-categories");
  const pillsSectionDesktop = document.querySelector(".pills-section-desktop");

  const specialClose = document.querySelector("#mobile-nav-desktop-close");
  const specialOpen = document.querySelector("#mobile-nav-desktop-open");
  const searchOpen = document.querySelector("#search-nav-desktop-open");
  const search404Open = document.querySelector("#search-nav-404-open");

  const openMegaMenu = () => {
    document.body.style.overflowY = "hidden";
    document.querySelectorAll(".search-box").forEach((el) => {
      // const inputEvent = new Event('input', { bubbles: true, cancelable: true });
      const input = el.querySelector("input");
      setTimeout(() => {
        input.focus();
      }, 1);
    });
    searchBoxDesktop.classList.add("show");
    navItems.classList.add("show");
    headerCategories.classList.add("hide-mobile");
    navbar.classList.add("mm-show");
  };

  navItems.addEventListener("scroll", (e) => {
    const currentScroll = navItems.scrollTop;
    if (currentScroll > 20) {
      pillsSectionDesktop.style.display = "none";
    } else {
      pillsSectionDesktop.style.display = "block";
    }
  });

  specialClose.addEventListener("click", (e) => {
    searchBoxDesktop.classList.remove("show");
    headerCategories.classList.remove("hide-mobile");
    navItems.classList.remove("show");
    document.body.style.overflowY = "scroll";
  });
  specialOpen.addEventListener("click", (e) => {
    openMegaMenu();
  });

  if (search404Open) {
    search404Open.addEventListener("click", (e) => {
      openMegaMenu();
    });
  }

  searchOpen.addEventListener("click", (e) => {
    openMegaMenu();
  });

  const mobileNavs = document.querySelectorAll(".mobile-nav-btn");
  mobileNavs.forEach((mobileNav) => {
    if (
      mobileNav.id == "mobile-nav-desktop-close" ||
      mobileNav.id == "mobile-nav-desktop-open"
    )
      return;
    document.addEventListener("click", (e) => {
      if (e.target.tagName == "INPUT") return;
      if (!navbar.contains(e.target) && e.target.id != "search-nav-404-open") {
        mobileNav.setAttribute("data-open", "false");
        searchBoxDesktop.classList.remove("show");
        headerCategories.classList.remove("hide-mobile");
        navItems.classList.remove("show");
        document.body.style.overflowY = "scroll";
      }
    });

    mobileNav.addEventListener("click", () => {
      if (mobileNav.dataset.open === "true") {
        mobileNav.setAttribute("data-open", "false");
        searchBoxDesktop.classList.remove("show");
        headerCategories.classList.remove("hide-mobile");
        navItems.classList.remove("show");
        document.body.style.overflowY = "scroll";
      } else {
        mobileNav.setAttribute("data-open", "true");
        openMegaMenu();
      }
    });
  });
}

//Handle Dropdowns
function handleDropdown() {
  const dropdowns = document.querySelectorAll(".dropdown");
  const dropdownItems = document.querySelectorAll(
    ".dropdown li,#lang-switcher li",
  );
  const dropdownBtns = document.querySelectorAll(
    ".dropdown button,#lang-switcher button",
  );
  const toggleDropdown = (dropdown) => {
    if (dropdown.dataset.open === "true") {
      dropdown.setAttribute("data-open", "false");
    } else {
      dropdown.setAttribute("data-open", "true");
    }
  };
  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener("click", () => {
      toggleDropdown(dropdown);
    });
  });
}
//Handle Language Switcher
function handleLanguageSwitcher() {
  const langSwitcher = document.getElementById("lang-switcher");
  const langSwitcherBtn = document.getElementById("lang-switcher-btn");
  const langSwitcherContent = document.getElementById("lang-switcher-content");
  var allLocales = [];

  if (langSwitcherBtn) {
    // Add click event for the entire lang-switcher container
    langSwitcher.addEventListener("click", function (e) {
      e.stopPropagation();
      toggleDropdown(langSwitcher);
    });

    // Add keyboard support for Safari
    langSwitcher.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleDropdown(langSwitcher);
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (!langSwitcher.contains(e.target)) {
        langSwitcher.setAttribute("data-open", "false");
      }
    });

    // Add mouseleave event ONCE, outside of setSelectedLocale
    langSwitcher.addEventListener("mouseleave", function () {
      langSwitcher.setAttribute("data-open", "false");
      // Remove the blur() as it interferes with click events
    });

    //locale = ISO language code (e.g. 'en') - ISO Alpha 2 Country Code (e.g. 'GB')
    //E.g. for English in Britain will be en-GB
    //Get ISO-3166 Country codes from https://www.iban.com/country-codes
    //Get Language codes from https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes, https://www.andiamo.co.uk/resources/iso-language-codes/
    //Both language code and country code should be 2 characters only.
    //Some examples:
    //"en-GB","ar-SA","zh-CN","de-DE","es-ES","fr-FR","hi-IN","it-IT","id-ID","ja-JP","ko-KR","nl-NL","no-NO","pl-PL","pt-BR","sv-SE","fi-FI","th-TH","tr-TR","uk-UA","vi-VN","ru-RU","he-IL"
    // const locales = GLOBAL.LOCALES.split(',');
    const locales = GLOBAL.LOCALES.split(",")
      .map((loc) => loc.trim())
      .filter((loc) => loc.length > 0); // HAPUS YANG KOSONG

    const getFlagSrc = (countryCode) => {
      return /^[A-Z]{2}$/.test(countryCode)
        ? `https://flagsapi.com/${countryCode.toUpperCase()}/flat/64.png`
        : "";
    };

    const toggleDropdown = (dropdown) => {
      const isOpen = dropdown.dataset.open === "true";
      dropdown.setAttribute("data-open", isOpen ? "false" : "true");

      // Safari-specific focus management
      if (!isOpen) {
        dropdown.focus();
      }
    };

    const setSelectedLocale = (locale) => {
      const intlLocale = new Intl.Locale(locale);
      const langName = new Intl.DisplayNames([locale], {
        type: "language",
      }).of(intlLocale.language);
      langSwitcherContent.innerHTML = "";
      const otherLocales = locales.filter((loc) => loc !== locale);

      otherLocales.forEach((otherLocale) => {
        const currLocale = new Intl.Locale(otherLocale).language;
        allLocales.push(currLocale);
      });

      otherLocales.forEach((otherLocale) => {
        const otherIntlLocale = new Intl.Locale(otherLocale);
        const otherLangName = new Intl.DisplayNames([otherLocale], {
          type: "language",
        }).of(otherIntlLocale.language);
        const localeURL = getLocaleURL(otherIntlLocale.language);

        const listEl = document.createElement("li");
        listEl.tabIndex = "0";

        listEl.innerHTML = `<a id="localeURL${otherIntlLocale}" href="${localeURL}" style="margin-left: 0.5rem;height: 1.15rem;">
                                        <i class="fi fi-${otherIntlLocale.region.toLowerCase()}" data-locale="${otherIntlLocale}"></i>
                                    </a>
                                    <a href="${localeURL}" style="padding-top:5px;text-wrap: nowrap; flex-grow: 1;">${otherLangName}</a>`;
        listEl.value = otherLocale;
        listEl.addEventListener("click", function () {
          setSelectedLocale(otherLocale);
        });
        listEl.addEventListener("keypress", function (e) {
          if (e.key === "Enter") setSelectedLocale(otherLocale);
        });
        langSwitcherContent.appendChild(listEl);
      });
      /*langSwitcher.addEventListener("mouseleave", () => {
                document.activeElement.blur();
            });*/
      let flagIcon = `<img alt="flagdd" data-locale="${intlLocale}" src="${getFlagSrc(intlLocale.region)}" />`;
      flagIcon = `<i class="fi fi-${intlLocale.region.toLowerCase()}" data-locale="${intlLocale}"></i>`;
      langSwitcherBtn.innerHTML =
        flagIcon +
        `
                                         <span class="lang-name">${langName}</span>
                                         <img src="/assets/img/arrow.svg" alt="arrow" aria-hidden="true" class="arrow-icon hidden xs:block filter-theme-header h-3.5 transition-transform duration-300"/>`;
    };

    setSelectedLocale(locales[0]);
    const browserLang = new Intl.Locale(navigator.language).language;
    if (GLOBAL.REDIRECT_ON_LOCALE === "true") {
      if (browserLang !== GLOBAL.ROOT_LOCALE) {
        setSelectedLocale(
          locales[
            locales.findIndex((element) => element.includes(browserLang + "-"))
          ],
        );
        window.location = getLocaleURL(browserLang);
      }
    } else {
      setSelectedLocale(
        locales[
          locales.findIndex((element) =>
            element.includes(GLOBAL.ROOT_LOCALE + "-"),
          )
        ],
      );
    }
  }
}
//Handle Scroll To Top
function handleScrollToTop() {
  const scrollToTop = document.getElementById("scroll-to-top");
  const pageProgress = document.getElementById("page-progress");
  scrollToTop.addEventListener("click", () => {
    window.scrollTo(0, 0);
  });
  window.addEventListener("scroll", () => {
    if (shouldIgnoreScroll() || isKeyboardOpen()) return; // kalau lagi ada input focus jangan handle, biarin.

    const scrollPercentage =
      window.scrollY / (document.body.clientHeight - window.innerHeight);
    pageProgress.style.strokeDashoffset = `${(1 - scrollPercentage) * 305}`;
    if (window.scrollY >= window.innerHeight / 2) {
      scrollToTop.setAttribute("data-visible", "true");
    } else {
      scrollToTop.setAttribute("data-visible", "false");
    }

    const el = document.activeElement;

    if (
      el &&
      (el.tagName === "INPUT" ||
        el.tagName === "TEXTAREA" ||
        el.isContentEditable)
    ) {
      return; // jangan ganggu user ngetik
    }

    el?.blur();
  });
}
//Handle Ticker
function handleTickerWithAutoHide() {
  const ticker = document.getElementById("ticker");
  if (ticker) {
    const tickerVisibility = localStorage.getItem("ticker");
    if (tickerVisibility === "hidden" || tickerVisibility === "visible") {
      ticker.dataset.visible = tickerVisibility;
      localStorage.setItem("ticker", tickerVisibility);
    }

    const closeTicker = document.getElementById("close-ticker");
    closeTicker.addEventListener("click", () => {
      ticker.dataset.visible = "hidden";
      localStorage.setItem("ticker", "hidden");

      // Trigger header position recalculation
      // Small delay to allow ticker to hide first
      setTimeout(() => {
        if (window.updateHeaderPositions) {
          window.updateHeaderPositions();
        }
      }, 10);
    });

    const scrollers = document.querySelectorAll(".scroller");
    const infiniteScrollAnimation = () => {
      scrollers.forEach((scroller) => {
        const scrollerInner = scroller.querySelector(".scroller-inner");
        const scrollerContent = Array.from(scrollerInner.children);
        scrollerContent.forEach((el) => {
          const duplicatedItem = el.cloneNode(true);
          scrollerInner.appendChild(duplicatedItem);
        });
      });
    };
    infiniteScrollAnimation();
  }
}

//Handle Top Menu Categories
function handleMenuCategories() {
  const categoryContainer = document.getElementById("category-container");
  const header = document.querySelector("header");
  const navItems = document.getElementById("nav-items");
  const mobileNav = document.getElementById("mobile-nav");
  const dropdowns = document.querySelectorAll(".dropdown");
  const resizeObserver = new ResizeObserver((entries) => {
    if (window.innerWidth >= 991) {
      dropdowns.forEach((dropdown) => {
        dropdown.addEventListener("mouseover", () => {
          dropdown.setAttribute("data-open", "true");
        });
        dropdown.addEventListener("mouseleave", () => {
          dropdown.setAttribute("data-open", "false");
        });
      });
    }

    if (categoryContainer.scrollWidth > categoryContainer.offsetWidth) {
      categoryContainer.style.justifyContent = "start";
    } else {
      categoryContainer.style.justifyContent = "center";
    }
  });

  resizeObserver.observe(document.body);
}
//Handle Accordians
function handleAccordians() {
  //accordian
  const accordians = document.querySelectorAll(`.accordian`);
  if (accordians) {
    const accordianHeaders = document.querySelectorAll(`.accordian-header`);
    accordianHeaders.forEach((accordianHeader) => {
      accordianHeader.addEventListener("click", () => {
        const prevSiblings = [];
        let prevSibling = accordianHeader.parentElement.previousElementSibling;
        while (prevSibling) {
          const el = prevSibling;
          prevSiblings.push(prevSibling);
          prevSibling = el.previousElementSibling;
        }
        if (prevSiblings)
          prevSiblings.forEach((el) => {
            el.setAttribute("data-open", "false");
          });

        const nextSiblings = [];
        let nextSibling = accordianHeader.parentElement.nextElementSibling;
        while (nextSibling) {
          const el = nextSibling;
          nextSiblings.push(nextSibling);
          nextSibling = el.nextElementSibling;
        }
        if (nextSiblings)
          nextSiblings.forEach((el) => {
            el.setAttribute("data-open", "false");
          });
        const open = accordianHeader.parentElement.dataset.open;
        if (open === "true")
          accordianHeader.parentElement.setAttribute("data-open", "false");
        else accordianHeader.parentElement.setAttribute("data-open", "true");
      });
    });
  }
}
//Handle Load More
const handleLoadMore = () => {
  // init
  const loadMoreBtn = document.querySelector(".js-load-posts");
  // show articles number in pagination
  var currPage = GLOBAL.CURRENT_PAGE + 1;
  var postsPerPage = GLOBAL.POSTS_PER_PAGE;
  var totalPages = GLOBAL.MAX_PAGES;
  var totalPosts = GLOBAL.TOTAL_POSTS;
  var showingArticles = currPage * postsPerPage;

  if (loadMoreBtn && GLOBAL.LAST_PAGE) {
    loadMoreBtn.disabled = true;
    loadMoreBtn.classList.add("btn-disabled");
    loadMoreBtn.innerHTML = "No more posts";
    showingArticles = totalPosts;
    var currArticles = document.getElementById("currArticles");
    currArticles.innerHTML = showingArticles;
  }

  // event
  if (loadMoreBtn) {
    loadMoreBtn.onclick = (event) => {
      loadMorePosts(event.srcElement);
      currPage = GLOBAL.CURRENT_PAGE + 1;
      showingArticles = currPage * postsPerPage;

      if (currPage === totalPages || totalPages < 2) {
        showingArticles = totalPosts;
      }
      setTimeout(function () {
        var currArticles = document.getElementById("currArticles");
        currArticles.innerHTML = showingArticles;
      }, 1000);
    };
  }
};
//Load more posts
const loadMorePosts = (button) => {
  // next link
  const nextPage = document.querySelector("link[rel=next]");
  GLOBAL.NEXT_PAGE_LINK =
    nextPage && !GLOBAL.NEXT_PAGE_LINK
      ? nextPage.getAttribute("href")
      : GLOBAL.NEXT_PAGE_LINK;

  // Update current page value
  if (GLOBAL.NEXT_PAGE_LINK && !GLOBAL.LAST_PAGE) {
    button ? button.classList.add("is-loading") : "";

    // Fetch next page content
    fetch(GLOBAL.NEXT_PAGE_LINK)
      .then((res) => res.text())
      .then((text) => new DOMParser().parseFromString(text, "text/html"))
      .then((doc) => {
        // Get posts
        const posts = doc.querySelectorAll(".js-post-card");
        const postContainer = document.querySelector(".js-post-list");
        const nextPage = doc.querySelector("link[rel=next]");

        // Add each post to the page
        posts.forEach((post) => {
          postContainer.appendChild(post);
        });

        // Update GLOBALS
        GLOBAL.CURRENT_PAGE = GLOBAL.CURRENT_PAGE + 1;
        GLOBAL.NEXT_PAGE_LINK = nextPage ? nextPage.getAttribute("href") : "";
        GLOBAL.NEXT_PAGE = GLOBAL.NEXT_PAGE_LINK ? GLOBAL.NEXT_PAGE + 1 : NaN;
        GLOBAL.LAST_PAGE =
          GLOBAL.CURRENT_PAGE === GLOBAL.MAX_PAGES ? true : false;

        // Disable button on last page
        if (button && GLOBAL.LAST_PAGE) {
          button.disabled = true;
          button.classList.add("btn-disabled");
          button.innerHTML = "No more posts";
        }

        button ? button.classList.remove("is-loading") : "";
      })
      .catch(function (err) {
        // There was an error
        console.warn("Something went wrong.", err);
      });
  }
};

//Handle External links
const handleExternalLinks = () => {
  if (GLOBAL.OPEN_LINKS_IN_NEW_TAB) {
    const domain = location.host.replace("www.", "");
    const postLinks = document.querySelectorAll("body a");
    postLinks.forEach((link) => {
      const linkURL = link.href.includes("?ref=")
        ? link.href.split("?ref=")[0]
        : link.href;
      if (!linkURL.includes(domain)) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noreferrer noopener");
      }
    });
  }
};

//Handle Gallery
const handleGallery = () => {
  //const images = document.querySelectorAll('.kg-gallery-image img');
  const images = document.querySelectorAll(
    ".kg-image-card img, .kg-gallery-card img",
  );
  const galleryImages = document.querySelectorAll(".kg-gallery-image img");

  // Gallery style
  galleryImages.forEach((image) => {
    image.setAttribute("alt", "Gallery Image");
    var container = image.closest(".kg-gallery-image");
    var width = image.attributes.width.value;
    var height = image.attributes.height.value;
    var ratio = width / height;
    container.style.flex = `${ratio} 1 0%`;
  });

  // Lighbox function
  if (GLOBAL.ENABLE_IMAGE_LIGHTBOX) {
    images.forEach((image) => {
      const link =
        image.parentNode.nodeName === "A"
          ? image.parentNode.getAttribute("href")
          : "";
      var lightboxWrapper = link
        ? image.parentNode
        : document.createElement("a");

      lightboxWrapper.setAttribute("data-no-swup", "");
      lightboxWrapper.setAttribute("data-fslightbox", "");
      lightboxWrapper.setAttribute("href", image.src);
      lightboxWrapper.setAttribute("aria-label", "Click for Lightbox");

      if (link) {
        var linkButton = document.createElement("a");
        linkButton.innerHTML =
          '<i class="icon icon-link icon--xs"><svg class="icon__svg"><use xlink:href="/assets/icons/feather-sprite.svg#link"></use></svg></i>';
        linkButton.setAttribute("class", "image-link");
        linkButton.setAttribute("href", link);
        if (GLOBAL.OPEN_LINKS_IN_NEW_TAB) {
          linkButton.setAttribute("target", "_blank");
          linkButton.setAttribute("rel", "noreferrer noopener");
        }
        lightboxWrapper.parentNode.insertBefore(
          linkButton,
          lightboxWrapper.parentNode.firstChild,
        );
      } else {
        image.parentNode.insertBefore(
          lightboxWrapper,
          image.parentNode.firstChild,
        );
        lightboxWrapper.appendChild(image);
      }
    });
    refreshFsLightbox();
  }
  GLOBAL.ENABLE_IMAGE_LIGHTBOX ? refreshFsLightbox() : "";
};

//Responsive Embeds
(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? (module.exports = factory())
    : typeof define === "function" && define.amd
      ? define(factory)
      : ((global = global || self), (global.reframe = factory()));
})(this, function () {
  "use strict";

  function reframe(target, cName) {
    var frames =
      typeof target === "string" ? document.querySelectorAll(target) : target;
    var c = cName || "js-reframe";
    if (!("length" in frames)) frames = [frames];
    for (var i = 0; i < frames.length; i += 1) {
      var frame = frames[i];
      var hasClass = frame.className.split(" ").indexOf(c) !== -1;
      if (hasClass || frame.style.width.indexOf("%") > -1) continue;
      var h = frame.getAttribute("height") || frame.offsetHeight;
      var w = frame.getAttribute("width") || frame.offsetWidth;
      var padding = (h / w) * 100;
      var div = document.createElement("div");
      div.className = c;
      var divStyles = div.style;
      divStyles.position = "relative";
      divStyles.width = "100%";
      divStyles.paddingTop = padding + "%";
      var frameStyle = frame.style;
      frameStyle.position = "absolute";
      frameStyle.width = "100%";
      frameStyle.height = "100%";
      frameStyle.left = "0";
      frameStyle.top = "0";
      frame.parentNode.insertBefore(div, frame);
      frame.parentNode.removeChild(frame);
      div.appendChild(frame);
    }
  }

  return reframe;
});

function handleTheme() {
  //Handling theme
  const themeToggle = document.getElementById("theme-toggler");

  const currentTheme = localStorage.getItem("theme")
    ? localStorage.getItem("theme")
    : document.documentElement.dataset.theme;

  if (currentTheme) {
    localStorage.setItem("theme", currentTheme);
    document.documentElement.setAttribute("data-theme", currentTheme);
  }

  const switchTheme = (e) => {
    const theme = localStorage.getItem("theme");
    if (theme) {
      if (theme === "light") {
        document.documentElement.setAttribute("data-theme", "dark");
        localStorage.setItem("theme", "dark");
      } else if (theme === "dark") {
        document.documentElement.setAttribute("data-theme", "light");
        localStorage.setItem("theme", "light");
      }
    }
  };

  if (themeToggle) {
    // Try with regular click listener (bubbling)
    themeToggle.addEventListener("click", switchTheme);

    // Also attach with capturing to be extra safe
    themeToggle.addEventListener("click", switchTheme, true);

    // Expose test functions to window for debugging
    window.testThemeSwitch = switchTheme;
    window.getThemeButton = () => document.getElementById("theme-toggler");
    window.getThemeValue = () => localStorage.getItem("theme");
    window.setDataTheme = (theme) =>
      document.documentElement.setAttribute("data-theme", theme);
    window.getDataTheme = () =>
      document.documentElement.getAttribute("data-theme");
    window.debugButton = () => {
      const btn = document.getElementById("theme-toggler");
      return {
        element: btn,
        visible: btn ? btn.offsetParent !== null : false,
        computedStyle: btn ? window.getComputedStyle(btn) : null,
        listeners: "Check console events",
      };
    };
  }
}

/**
 * DOM Loaded event
 */
export default function handler() {
  if (GLOBAL.AUTO_HIDE_HEADER) {
    window.updateHeaderPositions = handleHeaderWithAutoHide(); // Store the update function globally
    handleTickerWithAutoHide();
  } else {
    window.updateHeaderPositions = handleHeader(); // Store the update function globally
    handleTicker();
  }
  handleMobileNavigation();
  handleDropdown();
  handleLanguageSwitcher();
  handleScrollToTop();

  handleMenuCategories();
  handleAccordians();
  handleGallery();
  handleLoadMore();
  handleExternalLinks();
  handleTheme();
  reframe(
    'iframe:not([src*="soundcloud"]):not([src*="spotify"]):not(.no-resize)',
  );
}
